import React from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "../utils/helpers";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Loading = styled.div`
	border-radius: 50%;
	width: 29px;
	height: 29px;
	border: 5px solid ${colors.main};
	border-top-color: ${colors.grisclaro};
	animation: ${rotate360} 1s infinite linear;
	margin: 0 auto;
`;

const Loader = props => {
	return <Loading className="loading" />;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js